"use client"

import { Loader } from '@/components/ui/loader'

export default function RootLoading() {
  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <Loader size={56} label="Loading workspace..." />
    </div>
  )
}
